import React, { useEffect } from 'react';
import Icon from '../../../components/AppIcon';
import Button from '../../../components/ui/Button';

const SuccessConfirmation = ({ participantData, onContinue }) => {
  useEffect(() => {
    const timer = setTimeout(() => {
      onContinue();
    }, 5000);

    return () => clearTimeout(timer);
  }, [onContinue]);

  return (
    <div className="text-center space-y-6 animate-scale-in">
      <div className="flex justify-center">
        <div className="w-20 h-20 sm:w-24 sm:h-24 bg-success/10 rounded-full flex items-center justify-center animate-bounce">
          <Icon name="CheckCircle2" size={48} color="var(--color-success)" />
        </div>
      </div>
      <div className="space-y-2">
        <h2 className="text-2xl sm:text-3xl font-semibold text-foreground">
          ¡Registro completado!
        </h2>
        <p className="text-sm sm:text-base text-muted-foreground max-w-md mx-auto">
          Gracias por registrarte. Tu información ha sido guardada correctamente.
        </p>
      </div>
      <div className="bg-card rounded-xl p-4 sm:p-6 border border-border max-w-md mx-auto">
        <div className="space-y-3 text-left">
          <div className="flex items-center gap-3">
            <div className="w-10 h-10 bg-primary/10 rounded-lg flex items-center justify-center flex-shrink-0">
              <Icon name="Mail" size={20} color="var(--color-primary)" />
            </div>
            <div className="flex-1 min-w-0">
              <p className="text-xs text-muted-foreground">Correo electrónico</p>
              <p className="text-sm font-medium text-foreground truncate">{participantData?.email}</p>
            </div>
          </div>

          {participantData?.specialty && (
            <div className="flex items-center gap-3">
              <div className="w-10 h-10 bg-secondary/10 rounded-lg flex items-center justify-center flex-shrink-0">
                <Icon name="Stethoscope" size={20} color="var(--color-secondary)" />
              </div>
              <div className="flex-1 min-w-0">
                <p className="text-xs text-muted-foreground">Especialidad</p>
                <p className="text-sm font-medium text-foreground capitalize">{participantData?.specialty}</p>
              </div>
            </div>
          )}

          {participantData?.institution && (
            <div className="flex items-center gap-3">
              <div className="w-10 h-10 bg-accent/10 rounded-lg flex items-center justify-center flex-shrink-0">
                <Icon name="Building2" size={20} color="var(--color-accent)" />
              </div>
              <div className="flex-1 min-w-0">
                <p className="text-xs text-muted-foreground">Institución</p>
                <p className="text-sm font-medium text-foreground truncate">{participantData?.institution}</p>
              </div>
            </div>
          )}
        </div>
      </div>
      <div className="bg-primary/10 border border-primary/20 rounded-lg p-4 max-w-md mx-auto">
        <div className="flex items-start gap-3">
          <Icon name="Info" size={20} color="var(--color-primary)" className="flex-shrink-0 mt-0.5" />
          <div className="text-left text-sm text-foreground">
            <p className="font-medium mb-1">Próximos pasos</p>
            <p className="text-muted-foreground">
              Recibirás un correo de confirmación con los detalles de tu participación y cualquier premio que ganes durante el evento.
            </p>
          </div>
        </div>
      </div>
      <div className="flex flex-col sm:flex-row gap-3 justify-center pt-2">
        <Button
          variant="default"
          onClick={onContinue}
          iconName="Play"
          iconPosition="right"
          size="lg"
        >
          Ir a la ruleta
        </Button>
      </div>
      <p className="text-xs text-muted-foreground">
        Redirigiendo automáticamente en 5 segundos...
      </p>
    </div>
  );
};

export default SuccessConfirmation;